import styled from "styled-components";
import { Link } from "react-router-dom";

export const Button = styled(Link)`
  background: ${({ primary }) => (primary ? "#219653" : "#FFFFFF")};
  white-space: nowrap;
  outline: none;
  border: none;
  min-width: 100px;
  max-width: 200px;
  cursor: pointer;
  text-decoration: none;
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${(big) => (big ? "16px 40px" : "12px 20px")};
  color: ${({ primary }) => (primary ? "#FFFFFF" : "#219653")};
  font-size: ${({ big }) => (big ? "18px" : "16px")};

  &:hover {
    transform: translateY(-3px);
  }
`;
